{
	"title": "Confirmação necessária",
	"cancel": "Cancelar",
	"ok": "Ok"
}
